package com.vamvisions.main.core.presentation.i18n

import com.vamvisions.main.core.domain.DataError

/** Ids of the messages a ViewModel can emit without knowing the interface language. */
enum class StringKey {
    ERROR_NO_CONNECTION,
    ERROR_NOT_FOUND,
    ERROR_SERVER,
    ERROR_INVALID_RESPONSE,
    ERROR_UNKNOWN,
    ERROR_BAD_REQUEST,
    ERROR_TOO_MANY_REQUESTS,
    ERROR_FIELD_REQUIRED,
    ERROR_EMAIL_INVALID,
    ERROR_MESSAGE_REQUIRED,
    ERROR_MESSAGE_TOO_SHORT,
    ERROR_MESSAGE_TOO_LONG,
    ERROR_NAME_TOO_LONG,
    CONTACT_SENT,
    CONTACT_SEND_FAILED,
}

/** A text that is either already final ([Dynamic]) or looked up in the active [Strings] ([Res]). */
sealed interface UiText {
    data class Dynamic(val value: String) : UiText
    data class Res(val key: StringKey) : UiText
}

fun Strings.resolve(key: StringKey): String = when (key) {
    StringKey.ERROR_NO_CONNECTION -> errorNoConnection
    StringKey.ERROR_NOT_FOUND -> errorNotFound
    StringKey.ERROR_SERVER -> errorServer
    StringKey.ERROR_INVALID_RESPONSE -> errorInvalidResponse
    StringKey.ERROR_UNKNOWN -> errorUnknown
    StringKey.ERROR_BAD_REQUEST -> errorBadRequest
    StringKey.ERROR_TOO_MANY_REQUESTS -> errorTooManyRequests
    StringKey.ERROR_FIELD_REQUIRED -> errorFieldRequired
    StringKey.ERROR_EMAIL_INVALID -> errorEmailInvalid
    StringKey.ERROR_MESSAGE_REQUIRED -> errorMessageRequired
    StringKey.ERROR_MESSAGE_TOO_SHORT -> errorMessageTooShort
    StringKey.ERROR_MESSAGE_TOO_LONG -> errorMessageTooLong
    StringKey.ERROR_NAME_TOO_LONG -> errorNameTooLong
    StringKey.CONTACT_SENT -> contactSent
    StringKey.CONTACT_SEND_FAILED -> contactSendFailed
}

fun UiText.resolve(strings: Strings): String = when (this) {
    is UiText.Dynamic -> value
    is UiText.Res -> strings.resolve(key)
}

fun DataError.toUiText(): UiText = UiText.Res(
    when (this) {
        is DataError.Network -> when (type) {
            DataError.Network.Type.NO_CONNECTION -> StringKey.ERROR_NO_CONNECTION
            DataError.Network.Type.NOT_FOUND -> StringKey.ERROR_NOT_FOUND
            DataError.Network.Type.BAD_REQUEST -> StringKey.ERROR_BAD_REQUEST
            DataError.Network.Type.TOO_MANY_REQUESTS -> StringKey.ERROR_TOO_MANY_REQUESTS
            DataError.Network.Type.SERVER -> StringKey.ERROR_SERVER
            DataError.Network.Type.SERIALIZATION -> StringKey.ERROR_INVALID_RESPONSE
            DataError.Network.Type.UNKNOWN -> StringKey.ERROR_UNKNOWN
        }
    }
)
